import { RootState } from 'store/store';

const path = (state: RootState) => state.auth;

export const getToken = (state: RootState) => path(state).token;
